import React from 'react';

const NewsCard = ({ news }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('hi-IN', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const isUpcoming = (eventDate) => {
    return new Date(eventDate) > new Date();
  };

  return (
    <div className="bg-temple-bg-warm rounded-2xl shadow-temple overflow-hidden hover:shadow-temple-lg transition-all duration-300 hover:-translate-y-1 border border-temple-primary/10">
      {news.image && (
        <div className="h-48 overflow-hidden">
          <img 
            src={news.image} 
            alt={news.title}
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
          />
        </div>
      )}
      
      <div className="p-4 sm:p-6">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center space-x-2">
            <span className={`inline-block text-xs font-bold px-3 py-1 rounded-full ${
              isUpcoming(news.eventDate) 
                ? 'bg-green-100 text-green-700' 
                : 'bg-temple-text-muted/10 text-temple-text-muted'
            }`}>
              {isUpcoming(news.eventDate) ? 'आगामी' : 'संपन्न'}
            </span>
            {news.category && (
              <span className="inline-block bg-temple-secondary/20 text-temple-secondary text-xs font-bold px-3 py-1 rounded-full">
                {news.category}
              </span>
            )}
          </div>
          <span className="text-xs text-temple-text-muted">
            {formatDate(news.createdAt)}
          </span>
        </div>
        
        <h3 className="text-lg sm:text-xl font-serif font-bold text-temple-text mb-3 line-clamp-2 leading-tight">
          {news.title}
        </h3>
        
        <p className="text-temple-text-muted text-sm leading-relaxed mb-4 line-clamp-3">
          {news.description}
        </p>
        
        {news.eventDate && (
          <div className="flex items-center text-sm text-temple-primary mb-4">
            <span className="mr-2">📅</span>
            <span className="font-bold">
              कार्यक्रम दिनांक: {formatDate(news.eventDate)}
            </span>
          </div>
        )}
        
        {news.location && (
          <div className="flex items-center text-sm text-temple-text-muted">
            <span className="mr-2">📍</span>
            <span>{news.location}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsCard;